import React from "react";
import { Link } from 'react-scroll';

import './anchor-nav-item.scss';

const AnchorNavItem = ({data, onClickHandler}) => {
  return <li><Link onClick={onClickHandler} to={data} spy={true} smooth={true}>{data}</Link></li>;
}

export default AnchorNavItem;